import React from 'react'
import Button from '@components/V3/Button'
import useWidth from '@hooks/useWidth'
import useLoyaltyWallet from '@page-components/Checkout/CheckoutV2/LoyaltyProgram/loyalties/spoonity/hooks/useLoyaltyWallet'
import Link from 'next/link'

import GetLoyaltyRewards from '../hooks/getLoyaltyRewards'
import SkeletonSuspense from '../SkeletonSuspense'

import styles from './styles.module.css'

export default function LoyaltyRewards({websiteId, loginSuccess, activeLoyalty, user}) {
  const {loyaltyRewardsList, loading} = GetLoyaltyRewards(websiteId, loginSuccess)
  const width = useWidth()
  const isMobile = width < 768
  const {loyaltyWallet} = useLoyaltyWallet()

  const userName = user.name

  return (
    <SkeletonSuspense loading={loading}>
      <h1 className={styles.h1Text}>{activeLoyalty.sectionTitle}</h1>
      <div className={styles.rewardContainer}>
        <div className={styles.containerGrid}>
          {loyaltyRewardsList &&
            loyaltyRewardsList.map(reward => (
              <div className={styles.textGrid} key={reward.name}>
                <div className={styles.rewardName}>{reward.name}</div>

                <div className={styles.rewardDescription}>{reward.description}</div>
              </div>
            ))}
        </div>
        <div className={styles.pointsContainer}>
          <div className={styles.pointsTextContainer}>
            <div className={styles.welcomeText}>¡Hola! {userName}</div>
            <div className={styles.pointsContainerText}>
              {isMobile ? (
                <img
                  alt={activeLoyalty?.imagesWebMobile?.altBackgroundImg}
                  className={styles.imageMobile}
                  src={activeLoyalty?.imagesWebMobile?.backgroundImage?.url}
                />
              ) : (
                <img
                  alt={activeLoyalty?.imagesWeb?.altBackgroundImg}
                  className={styles.imageWeb}
                  src={activeLoyalty?.imagesWeb?.backgroundImage.url}
                />
              )}
              <div className={styles.childTextContainer}>
                <div className={styles.spoonCashText}>
                  Tus SpoonCash acumulados y listos para canjear
                </div>
                <div className={styles.points}>
                  {!loyaltyWallet && loyaltyWallet !== 0 ? (
                    <>
                      <div className={styles.errorText}> Error, intente nuevamente</div>
                    </>
                  ) : (
                    <>
                      <div className={styles.spoonCashPoints}>{loyaltyWallet}</div>
                      <div className={styles.rewardPoints}>{activeLoyalty.pointsTitle}</div>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
          <Link href="/pedir" className={styles.button}>

            <Button className={styles.pointsButton}>Ir a comprar</Button>

          </Link>
        </div>
      </div>
    </SkeletonSuspense>
  );
}
